import { useState, useEffect } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlidePartners } from './types'

export const usePartnersDetail = (businessIdeaId: string) => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [slidePartners, setSlidePartners] = useState<SlidePartners | null>(null)
  const [isSlidePartnersLoading, setIsSlidePartnersLoading] = useState(false)

  const getSlidePartnersDetail = async (id: string) => {
    if (!id) return

    setIsSlidePartnersLoading(true)

    try {
      const response = await apiClient.business.slidePartnersDetailList(id)
      setSlidePartners(response.data.partners)
    } catch (e) {
      console.error('オススメ共創パートナー企業の取得に失敗しました:', e)
      handleError(e as ApiErrorResponse, showSnackBar)
    } finally {
      setIsSlidePartnersLoading(false)
    }
  }

  useEffect(() => {
    if (businessIdeaId) {
      getSlidePartnersDetail(businessIdeaId)
    }
  }, [businessIdeaId])

  return {
    slidePartners,
    setSlidePartners,
    isSlidePartnersLoading,
    getSlidePartnersDetail,
  }
}
